import { render, staticRenderFns } from "./ContractDetail.vue?vue&type=template&id=01b30880&scoped=true"
import script from "./ContractDetail.vue?vue&type=script&lang=js"
export * from "./ContractDetail.vue?vue&type=script&lang=js"
import style0 from "./ContractDetail.vue?vue&type=style&index=0&id=01b30880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b30880",
  null
  
)

export default component.exports